import React from 'react';
import './Error404.css';
import Header from '../components/Layout/header';
import Footer from '../components/Layout/Footer';
import MainBtn from '../components/Common/Btn';
import { Link } from 'react-router-dom';

const Error404 = () => {
    return ( 
        <>
        <Header />
        <main>
            <div className="bgGrid"></div>
            <section className="errorCont">
                <div className="error">
                    <h1>404</h1>
                    <h5>We can’t find the page you are looking for</h5>
                    <Link className='link' to="/">
                        <MainBtn btnStyle="errorBtn" btnText="BACK TO HOME" />
                    </Link>
                </div>
            </section>
        </main>
        <Footer />
        </>
     );
}
 
export default Error404;